export * from '@core/components/fullscreen/fullscreen.component';
export * from '@core/components/fullscreen/fullscreen.module';
export * from '@core/components/fullscreen/fullscreen.types';
